import axios from "axios";
import { AuthContext } from "../../Hooks/context/AuthContext";
import { useContext } from "react";
import { Urls } from "../../App";

const useApiClient = () => {
  const { authTokens = {}, setTokens } = useContext(AuthContext) || {};
  const { accessToken, refreshToken, userId } = authTokens;
  const { baseURL, APIKey } = Urls();
  const api = axios.create({
    //  baseURL: "https://devapi.maxlifeinsurance.com/acr", // dev

    //baseURL: " https://uatapi.maxlifeinsurance.com/acr", // uat
    baseURL: baseURL,
    timeout: 10000,
    headers: {
      "Content-Type": "application/json",
      // "x-api-key": "U1HQLHNvZO8ewIKnaZEIv95fvF4zDfEu3h9aLuAI", //dev
      //"x-api-key": "aDOZwp6VeM74RDuuQFgpRVZAoVdjul5Dppz2Oh30", //uat
      "x-api-key": APIKey,
    },
  });

  let isRefreshing = false;
  let refreshQueue = [];

  const processQueue = (error, newAccessToken = null) => {
    refreshQueue.forEach((promise) => {
      if (error) {
        promise.reject(error);
      } else {
        promise.resolve(newAccessToken);
      }
    });
    refreshQueue = [];
  };

  api.interceptors.request.use(
    async (config) => {
      if (accessToken) {
        config.headers["Token"] = `Bearer ${accessToken}`;
      } else {
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  api.interceptors.response.use(
    async (response) => {
      const originalRequest = response.config;
      if (response.data.httpCode === 401) {
        if (response?.data?.httpCode === 401 && !originalRequest._retry) {
          if (isRefreshing) {
            return new Promise((resolve, reject) => {
              refreshQueue.push({ resolve, reject });
            })
              .then((newToken) => {
                originalRequest.headers["Token"] = `Bearer ${newToken}`;
                return api(originalRequest);
              })
              .catch((err) => Promise.reject(err));
          }

          originalRequest._retry = true;
          isRefreshing = true;

          try {
            const res = await refreshTokenApi();

            const newAccessToken = res?.response.accessToken;
            setTokens((prev) => ({
              ...prev,
              accessToken: newAccessToken,
            }));

            api.defaults.headers.common["Token"] = `Bearer ${newAccessToken}`;
            processQueue(null, newAccessToken);
            return api(originalRequest);
          } catch (refreshError) {
            processQueue(refreshError, null);
            return Promise.reject(refreshError);
          } finally {
            isRefreshing = false;
          }
        }
      } else if (
        response.data.httpCode !== 200 &&
        response.data.httpCode !== 401
      ) {
        return response;
      }
      return response;
    },

    async (error) => {
      return Promise.reject(error);
    }
  );

  const refreshTokenApi = async () => {
    try {
      const result = await api.post("/api/refresh", {
        refreshToken,
        userId,
      });
      return result.data;
    } catch (error) {
      throw error;
    }
  };

  return { api };
};

export default useApiClient;
